const storeProgress = {
  namespaced: true,
  state: {
    progressPercent: 0,
  },
  mutations: {
    set(state, data) {
      state.progressPercent = data;
    },
    hide(state) {
      state.progressPercent = 0;
    }
  }
};

export default storeProgress;



// WEBPACK FOOTER //
// ./src/framework/x-progress.js